import User from "admin/types/interfaces/user";
import queryString from "query-string";
import { SWRConfiguration } from "swr";
import { useV1List } from "~/hooks/useV1List";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useUsers = (
  {
    searchQuery,
    activeOnly = false,
    enabled = true,
  }: { searchQuery?: string; activeOnly?: boolean; enabled?: boolean } = {},
  options?: SWRConfiguration
) => {
  const qs = queryString.stringify({
    with_auth0: true,
    include_system_users: false,
    ...(searchQuery && { q: searchQuery }),
    ...(activeOnly && { active_only: activeOnly }),
  });
  const url = enabled ? `${ACCESS_CONTROLLER_V1}/users?${qs}` : null;
  return useV1List<User>(url, options);
};

export default useUsers;
